import { createReduxHistoryContext } from 'redux-first-history';
import { browserHistory } from './history';
var _a = createReduxHistoryContext({
    history: browserHistory,
}), createReduxHistory = _a.createReduxHistory, routerMiddleware = _a.routerMiddleware, routerReducer = _a.routerReducer;
export { createReduxHistory, routerMiddleware, routerReducer };
